/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsGetArtifacts } from "../../funcs/llmEvalsGetArtifacts.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetEvalArtifactsRequest$inboundSchema,
};

export const tool$llmEvalsGetArtifacts: ToolDefinition<typeof args> = {
  name: "llm-evals-get-artifacts",
  description: `Get eval run artifacts

Returns generated result and sample artifact file IDs for a completed eval run.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsGetArtifacts(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
